import { httpClient } from '../../../shared/api/httpClient';

export interface ClientContact {
  id: string;
  email: string;
  name?: string;
  phone?: string;
  is_main?: boolean;
}

export interface Client {
  id: string;
  name: string;
  uid?: string;
  type: string;
  region?: string;
  externalSite?: string;
  mainContact?: ClientContact;
  contacts: ClientContact[];
  externalData?: Record<string, any>;
}

export interface ClientsResponse {
  results: Client[];
  count: number;
  limit: number;
  offset: number;
}

export async function getClients(filters?: {
  search?: string;
  site?: string;
  limit?: number;
  offset?: number;
}): Promise<ClientsResponse> {
  const params = new URLSearchParams();
  if (filters?.search) {
    params.append('search', filters.search);
  }
  if (filters?.site) {
    params.append('site', filters.site);
  }
  if (filters?.limit) {
    params.append('limit', String(filters.limit));
  }
  if (filters?.offset) {
    params.append('offset', String(filters.offset));
  }

  const queryString = params.toString();
  const url = `/tickets/clients/${queryString ? `?${queryString}` : ''}`;
  
  return httpClient.get<ClientsResponse>(url);
}

export async function getClientById(id: string): Promise<Client | null> {
  try {
    return await httpClient.get<Client>(`/tickets/clients/?id=${id}`);
  } catch (error) {
    console.error('Ошибка загрузки клиента:', error);
    return null;
  }
}

export async function updateClient(id: string, data: Partial<Client>): Promise<Client> {
  return httpClient.put<Client>(`/tickets/clients/${id}/`, data);
}

export async function getClientTickets(clientId: string): Promise<any[]> {
  const params = new URLSearchParams();
  params.append('clientId', clientId);
  return httpClient.get<any[]>(`/tickets/?${params.toString()}`);
}
